import React, { CSSProperties } from 'react';
import type { TaskStatus } from '@bringg/types';
import { isTaskStarted } from '../../../../../utils/bringgTypesTransformers';

interface Props {
	taskStatus: TaskStatus;
	color: string;
}

const ColorMarkColumn = ({ taskStatus, color }: Props) => {
	const taskStatusStyle = isTaskStarted(taskStatus) ? { backgroundColor: color, opacity: 0.5 } : undefined;

	return (
		<>
			<div className="color-mark" data-test-id="color-mark" style={{ backgroundColor: color } as CSSProperties} />
			<div className="status-color-mark" style={taskStatusStyle} />
		</>
	);
};

export default ColorMarkColumn;
